<template lang='pug'>
div#contentContainer
  Day6Editor(:id="id")
</template>

<script>
import Day6Editor from './day6-editor'

export default {
  name: 'Day6Main',
  components: { Day6Editor },
  props: {
    id: String
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/app_content_container_scoped";
</style>
